export enum StopState {
  Crouch = "crouch",
  Prone = "prone",
  Cover = "cover",
}
